import { useEffect } from "react";
import "./Bridge.css";

const WEB_PAGE_PATH = "/";

// 금뚝딱 앱 딥링크 스킴 (앱의 Info.plist / AndroidManifest 와 일치해야 함)
const DEEP_LINK_SCHEME = "goldttakshare://bridge";
const APPLE_STORE_URL =
  "https://apps.apple.com/kr/app/%EA%B8%88%EB%9A%9D%EB%94%B1/id6748942265";
const ANDROID_PACKAGE = "com.goldttak.goldttak_app";
const GOOGLE_PLAY_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;

// URL 파라미터를 Play 설치 referrer로 전달 (앱이 설치 후 Install Referrer API로 읽을 수 있음)
function getGooglePlayUrl() {
  const queryString = new URLSearchParams(window.location.search).toString();
  if (!queryString) return GOOGLE_PLAY_URL;
  return `${GOOGLE_PLAY_URL}&referrer=${encodeURIComponent(queryString)}`;
}

function BridgeGoldttak() {
  const goWebPage = () => {
    window.location.href = WEB_PAGE_PATH;
  };

  // 모바일 앱 딥링크 처리, 앱이 없으면 스토어로 이동
  const openApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/i.test(userAgent);

    if (!isIOS && !isAndroid) {
      // 데스크톱에서는 금뚝딱 홈으로 이동
      goWebPage();
      return;
    }

    // URL 파라미터 유지 (userKey 등)
    const queryString = new URLSearchParams(window.location.search).toString();
    const deepLink = queryString
      ? `${DEEP_LINK_SCHEME}?${queryString}`
      : DEEP_LINK_SCHEME;
    if (isAndroid) {
      // Android: intent:// 로 열면 앱이 없을 때 브라우저가 직접 Play Store(fallback)로 이동
      // (커스텀 스킴은 앱이 없으면 에러 페이지로 바뀌거나 무시되어 스토어 이동이 실패함)
      const fallbackUrl = encodeURIComponent(getGooglePlayUrl());
      const query = queryString ? `?${queryString}` : "";
      window.location.href =
        `intent://bridge${query}#Intent;scheme=goldttakshare;` +
        `package=${ANDROID_PACKAGE};S.browser_fallback_url=${fallbackUrl};end`;
      return;
    }

    // iOS: 앱이 열리면 페이지가 백그라운드로 감(visibilitychange / pagehide).
    // 앱이 없으면 Safari "주소가 유효하지 않음" 알림만 뜨고 페이지는 그대로이므로 App Store로 이동.
    // (blur / hasFocus는 이 알림 때문에 '앱 열림'으로 오판되므로 사용하지 않음)
    let appOpened = false;
    const markOpened = () => {
      if (document.hidden) appOpened = true;
    };
    const handlePageHide = () => {
      appOpened = true;
    };

    document.addEventListener("visibilitychange", markOpened);
    window.addEventListener("pagehide", handlePageHide);

    window.location.href = deepLink;

    setTimeout(() => {
      document.removeEventListener("visibilitychange", markOpened);
      window.removeEventListener("pagehide", handlePageHide);

      if (!appOpened && !document.hidden) {
        window.location.href = APPLE_STORE_URL;
      }
    }, 2500);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      openApp();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bridge-container">
      <div className="bridge-content">
        <h1 className="bridge-title">앱을 여는 중...</h1>
        <p className="bridge-message">잠시만 기다려주세요.</p>
        <button className="bridge-button" onClick={openApp}>
          앱 바로가기
        </button>
      </div>
    </div>
  );
}

export default BridgeGoldttak;
